import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable,EventEmitter } from "@angular/core";
import { BehaviorSubject, Observable, timer } from "rxjs";
import { ApiRequestService } from "src/app/services/api-request/api-request.service";
import { debounce } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
export class UserManagerService{

  // public GET_USER_LIST = environment.apiUrl + '/v2/api/ci-user';
  // public GET_TEAM_LIST = environment.apiUrl + '/v2/api/team';
  // public CREATE_USER = environment.apiUrl + '/v2/api/ci-user';
  // public CREATE_TEAM = environment.apiUrl + '/v2/api/team';
  // public UPDATE_USER = environment.apiUrl + '/v2/api/ci-user';
  // public UPDATE_USER_STATUS = environment.apiUrl + '/v2/api/ci-user/update';
  // public UPDATE_TEAM = environment.apiUrl + '/v2/api/team';
  // public GET_ORGANIZATION_LIST = environment.apiUrl + '/v2/api/organizationsAllData';
  // public UPDATE_ORGANIZATION = environment.apiUrl + '/v2/api/organizations';
  // public CREATE_ORGANIZATION = environment.apiUrl + '/v2/api/organizations';

    public GET_USER_LIST = '/v2/api/ci-user';
    public GET_TEAM_LIST = '/v2/api/team';
    public CREATE_USER = '/v2/api/ci-user';
    public CREATE_TEAM = '/v2/api/team';
    public UPDATE_USER = '/v2/api/ci-user';
    public UPDATE_USER_STATUS = '/v2/api/ci-user/update';
    public UPDATE_TEAM = '/v2/api/team';
    // public GET_ORGANIZATION_LIST = '/v2/api/organizations';
    public GET_ORGANIZATION_LIST = '/v2/api/organizationsAllData';
    public UPDATE_ORGANIZATION = '/v2/api/organizations';
    public CREATE_ORGANIZATION = '/v2/api/organizations';
    public searchText: string = '';
    public isOpen: boolean = false;
    public isLoading: boolean = false;
    public sidenav2Open: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public userSearchEvent: EventEmitter<string> = new EventEmitter<string>();
    public orgSearchEvent: EventEmitter<string> = new EventEmitter<string>();
    public unmappedUserSearchEvent: EventEmitter<string> = new EventEmitter<string>();
    public httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
        params:{}
      };

    constructor(private http:HttpClient, private apiRequest: ApiRequestService) {
        this.sidenav2Open.subscribe((value) => { this.isOpen = value; });
    }
    getUnmappedUserList(query):Observable<any>{
      let opt = {};
      opt['query'] = query
      return this.apiRequest.request('GET','/v2/api/unmapped-user',{},opt).pipe(
        debounce(() => timer(1000))
      );
    }
    getUserList(query,type?):Observable<any>{
      // this.httpPostOptions.params = query;
      // if (team_uuid && team_uuid != '') {
      //   return this.http.get(this.GET_USER_LIST+'/'+team_uuid, this.httpPostOptions);
      // }else{
      //   return this.http.get(this.GET_USER_LIST, this.httpPostOptions);
      // }


      let opt = {};
      if(type && type == 'updateProject'){
        query['isPagination'] = false;
      }
      opt['query'] = query

      return this.apiRequest.request('GET',this.GET_USER_LIST,{},opt).pipe(
        debounce(() => timer(1000))
      );
    }
    getTeamList(query?: any):Observable<any>{
      // this.httpPostOptions.params = query;
      let opt = {};
      if(query) {
        opt['query'] = query
      }
      return this.apiRequest.request('GET',this.GET_TEAM_LIST,{},opt);
      // return this.http.get(this.GET_TEAM_LIST, this.httpPostOptions);
    }
    getTeamDetails(uuid):Observable<any>{
      // console.log("url is", this.GET_TEAM_LIST+'/'+uuid)
      // this.httpPostOptions.params = {};
      let pathUrl = this.GET_TEAM_LIST+'/'+uuid
      return this.apiRequest.request('POST',pathUrl);
      // return this.http.get(this.GET_TEAM_LIST+'/'+uuid, this.httpPostOptions);
    }
    createUser(data):Observable<any>{
      return this.apiRequest.request('POST',this.CREATE_USER,data)
      // return this.http.post(this.CREATE_USER, data, this.httpPostOptions);
    }
    createTeam(data):Observable<any>{
      return this.apiRequest.request('POST',this.CREATE_TEAM,data);
      // return this.http.post(this.CREATE_TEAM, data, this.httpPostOptions);
    }
    updateUser(data):Observable<any>{
      return this.apiRequest.request('PUT',this.UPDATE_USER,data);
      // return this.http.put(this.UPDATE_USER, data, this.httpPostOptions);
    }
    updateUserStatus(data):Observable<any>{
      return this.apiRequest.request('POST',this.UPDATE_USER_STATUS,data);
      // return this.http.post(this.UPDATE_USER_STATUS, data, this.httpPostOptions);
    }
    updateUnmappedUser(data):Observable<any>{
      return this.apiRequest.request('PUT','/v2/api/unmapped-user',data);
      // return this.http.put(this.UPDATE_USER, data, this.httpPostOptions);
    }
    updateTeam(data):Observable<any>{
      return this.apiRequest.request('PUT',this.UPDATE_TEAM,data);
      // return this.http.put(this.UPDATE_TEAM, data, this.httpPostOptions);
    }

    
    getOrganizationList(query):Observable<any>{
      // this.httpPostOptions.params = query;
      let opt = {};
      opt['query'] = query
      return this.apiRequest.request('GET',this.GET_ORGANIZATION_LIST,{},opt);
      // return this.http.get(this.GET_ORGANIZATION_LIST, this.httpPostOptions);
    }
    createOrganization(data):Observable<any>{
      return this.apiRequest.request('POST',this.CREATE_ORGANIZATION,data);
      // return this.http.post(this.CREATE_ORGANIZATION, data, this.httpPostOptions);
    }
    updateOrganization(data):Observable<any>{
      return this.apiRequest.request('PUT',this.UPDATE_ORGANIZATION,data);
      // return this.http.put(this.UPDATE_ORGANIZATION, data, this.httpPostOptions);
    }
}